import type { EmptyStateProps } from '../types/layout';

const defaultIcon = (
  <i className="ti ti-layout-grid-add app-empty-state__icon-glyph" aria-hidden="true" />
);

const EmptyState = ({ title, message, icon = defaultIcon, action, className = '' }: EmptyStateProps) => {
  return (
    <div className={`app-empty-state ${className}`.trim()}>
      <div className="app-empty-state__icon">{icon}</div>
      <h3 className="app-empty-state__title">{title}</h3>
      {message && <p className="app-empty-state__message">{message}</p>}
      {action && <div className="app-empty-state__action">{action}</div>}
    </div>
  );
};

export default EmptyState;
